// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'
Vue.use(element)

import Drag from './components/drag.vue';
import eventBus from "../../../../../../util/eventBus";
import sourceData from "./common/sourecData.json";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
            console.log('-----update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.invoke = (eventName, args)=>{
                invoke(eventName, args)
            }

            new Vue({
                el: model.dom,
                template: '<Drag :cusParam_savetosite="cusParam_savetosite" :cusParam_configData="cusParam_configData" :cusParam_save="cusParam_save" :cusParam_cancle="cusParam_cancle" :themeNum="themeNum" :lang="lang" />',
                components: {
                    Drag
                },
                data: {
                    themeNum:"#5582F3",
                    lang:"zh_CN",
                    cusParam_configData:null,
                    cusParam_save:null,
                    cusParam_cancle:null,
                    cusParam_savetosite:null
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    if(props.themeNum){this.themeNum = props.themeNum;}
                    if(props.lang){this.lang = props.lang;}
                    if(props.data){
                        this.getCusParam(props,'cusParam_configData');
                    }
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if(props.themeNum){this.themeNum = props.themeNum;}
                        if(!props.data){return}
                        this.getCusParam(props,'cusParam_configData');
                        this.getCusParam(props,'cusParam_save');
                        this.getCusParam(props,'cusParam_cancle');
                        this.getCusParam(props,'cusParam_savetosite');
                    })
                },
                methods: {
                   getCusParam(props,key){
                       if(props.data.hasOwnProperty(key) && props.data[key]){
                           this[key] = props.data[key] ? JSON.parse(props.data[key]) : null;
                       }
                   }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('dragIntver', MyComponent,{
        isMulLang: true
    })
})(window.KDApi)
